
function Content(props) {
  const { body } = props;
  return <div>{body}</div>;
}

export default Content;
